import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  key: 0,
  style: {
    "color": "#1de51d"
  }
};
const _hoisted_2 = {
  key: 1,
  style: {
    "color": "#1de51d"
  }
};
const _hoisted_3 = {
  key: 2,
  style: {
    "color": "#1de51d"
  }
};
const _hoisted_4 = {
  key: 3,
  style: {
    "color": "orangered"
  }
};
import { searchFormItems } from './config';
import Error from './Error.vue';
import Result from './Result.vue';
import { LIST_URL, remove } from '@/api/system/task';
import { formatterDate } from '@/utils/common';
import { XTable } from '@/components/index';
import { ASYN_TASK_STATUS } from '@/constant/system/code';
import { deleteBox, toast } from '@/utils/message';

import { ref, onMounted, onBeforeUnmount } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Asyntask',
  setup(__props) {
    const tableInstance = ref();
    const ErrorDetailsRef = ref();
    const ResultDetailsRef = ref();
    function search(formData) {
      tableInstance.value?.load(formData);
    }
    function reset() {
      tableInstance.value?.load({});
    }
    function taskReuslt(row) {
      ResultDetailsRef.value?.open(row);
    }
    function taskError(row) {
      ErrorDetailsRef.value?.open(row.errorMessage);
    }
    function handleRemoveItem(data) {
      deleteBox().then(() => {
        remove(Array.of(data.taskId)).then(() => {
          toast.success('删除成功');
          tableInstance.value?.reLoad();
        });
      });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    function reloadTable() {
      tableInstance.value?.reLoad();
    }
    const timer = ref();
    onMounted(() => {
      timer.value = setInterval(reloadTable, 3000);
    });
    onBeforeUnmount(() => {
      if (timer.value) {
        clearInterval(timer.value);
      }
    });
    return (_ctx, _cache) => {
      const _component_XSearchForm = _resolveComponent("XSearchForm");
      const _component_ElTableColumn = _resolveComponent("ElTableColumn");
      const _component_el_link = _resolveComponent("el-link");
      const _component_XFlexCtx = _resolveComponent("XFlexCtx");
      const _component_XAppLayout = _resolveComponent("XAppLayout");
      const _directive_authority = _resolveDirective("authority");
      return _openBlock(), _createBlock(_component_XAppLayout, null, {
        default: _withCtx(() => [_createVNode(_component_XSearchForm, {
          ref: "searchForm",
          items: _unref(searchFormItems),
          onSearch: search,
          onReset: reset
        }, null, 8, ["items"]), _createVNode(_component_XFlexCtx, {
          flex: 1
        }, {
          default: _withCtx(() => [_createVNode(_unref(XTable), {
            ref_key: "tableInstance",
            ref: tableInstance,
            url: _unref(LIST_URL),
            "show-index": "",
            disableLoaddinig: "",
            disableDataReloading: "",
            responseConfig: {
              total: () => 0,
              data: data => data
            },
            "el-table-props": {
              border: true
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_ElTableColumn, {
              label: "任务编号",
              prop: "taskId",
              width: "300"
            }), _createVNode(_component_ElTableColumn, {
              label: "任务名称",
              prop: "taskName",
              width: "150"
            }), _createVNode(_component_ElTableColumn, {
              label: "开始时间",
              prop: "startTime",
              width: "160",
              align: "center",
              formatter: row => _unref(formatterDate)(row.startTime)
            }, null, 8, ["formatter"]), _createVNode(_component_ElTableColumn, {
              label: "结束时间",
              prop: "endTime",
              width: "160",
              align: "center",
              formatter: row => _unref(formatterDate)(row.endTime)
            }, null, 8, ["formatter"]), _createVNode(_component_ElTableColumn, {
              label: "过期/删除时间",
              prop: "expireTime",
              width: "160",
              align: "center",
              formatter: row => _unref(formatterDate)(row.expireTime)
            }, null, 8, ["formatter"]), _createVNode(_component_ElTableColumn, {
              label: "任务耗时(ms)",
              prop: "totalTime",
              width: "160"
            }), _createVNode(_component_ElTableColumn, {
              label: "任务状态",
              prop: "status",
              width: "160"
            }, {
              default: _withCtx(({
                row
              }) => [row.status.toString() === _unref(ASYN_TASK_STATUS).STARTED.CODE ? (_openBlock(), _createElementBlock("p", _hoisted_1, [_cache[0] || (_cache[0] = _createElementVNode("i", {
                class: "el-icon-caret-right status_i"
              }, null, -1)), _createTextVNode(_toDisplayString(_unref(ASYN_TASK_STATUS).STARTED.NAME), 1)])) : _createCommentVNode("", true), row.status.toString() === _unref(ASYN_TASK_STATUS).RUNNING.CODE ? (_openBlock(), _createElementBlock("p", _hoisted_2, [_cache[1] || (_cache[1] = _createElementVNode("i", {
                class: "el-icon-loading status_i"
              }, null, -1)), _createTextVNode(_toDisplayString(_unref(ASYN_TASK_STATUS).RUNNING.NAME), 1)])) : _createCommentVNode("", true), row.status.toString() === _unref(ASYN_TASK_STATUS).SUCCESS.CODE ? (_openBlock(), _createElementBlock("p", _hoisted_3, [_cache[2] || (_cache[2] = _createElementVNode("i", {
                class: "el-icon-circle-check status_i"
              }, null, -1)), _createTextVNode(_toDisplayString(_unref(ASYN_TASK_STATUS).SUCCESS.NAME), 1)])) : _createCommentVNode("", true), row.status.toString() === _unref(ASYN_TASK_STATUS).FAILED.CODE ? (_openBlock(), _createElementBlock("p", _hoisted_4, [_cache[3] || (_cache[3] = _createElementVNode("i", {
                class: "el-icon-circle-close status_i"
              }, null, -1)), _createTextVNode(_toDisplayString(_unref(ASYN_TASK_STATUS).FAILED.NAME), 1)])) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_ElTableColumn, {
              label: "操作",
              align: "center"
            }, {
              default: _withCtx(({
                row
              }) => [row.status.toString() === _unref(ASYN_TASK_STATUS).SUCCESS.CODE ? (_openBlock(), _createBlock(_component_el_link, {
                key: 0,
                type: "primary",
                onClick: $event => taskReuslt(row)
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("任务结果")])),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true), row.status.toString() === _unref(ASYN_TASK_STATUS).FAILED.CODE ? (_openBlock(), _createBlock(_component_el_link, {
                key: 1,
                type: "primary",
                onClick: $event => taskError(row)
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("错误日志")])),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true), row.status.toString() === _unref(ASYN_TASK_STATUS).FAILED.CODE || row.status.toString() === _unref(ASYN_TASK_STATUS).SUCCESS.CODE ? _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                key: 2,
                type: "primary",
                onClick: $event => handleRemoveItem(row)
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("删除")])),
                _: 2
              }, 1032, ["onClick"])), [[_directive_authority, 'system:task:delete']]) : _createCommentVNode("", true)]),
              _: 1
            })]),
            _: 1
          }, 8, ["url", "responseConfig"])]),
          _: 1
        }), _createVNode(Result, {
          ref_key: "ResultDetailsRef",
          ref: ResultDetailsRef
        }, null, 512), _createVNode(Error, {
          ref_key: "ErrorDetailsRef",
          ref: ErrorDetailsRef
        }, null, 512)]),
        _: 1
      });
    };
  }
});